export const toPhoneNumber = (str: string): string | null => {
  const cleaned = ('' + str).replace(/\D/g, '');

  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return null;
};

export const toE164 = (str?: string | null): string | undefined => {
  if (!str) {
    return undefined;
  }
  const cleaned = str.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `+1${cleaned}`;
  }
  return cleaned.length > 0 ? `+${cleaned}` : undefined;
};
